import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import "react-toastify/dist/ReactToastify.css";
import { InputLabel, Select, MenuItem } from "@mui/material";
import { IconButton } from "@mui/material";
import Chip from "@mui/material/Chip";
import CancelIcon from "@mui/icons-material/Cancel";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
// @mui material components
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import { keyframes } from "@mui/system";
import { Switch } from "@mui/material";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@mui/material';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

function Customers() {
  
    const [loading, setLoading] = useState(true);
    const [customerList, setCustomerList] = useState([]);

  const navigate = useNavigate();

  
    const fetchcustomerTypes = async () => {
      setLoading(true);

      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;

        if (!token) throw new Error("Authentication token not found.");

        const response = await axios.get("/api/customertype/disabled=false", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          console.log("Decrypted Customer Types:", decryptedData); 
          setCustomerList(decryptedData|| []);
      
        }
      } catch (error) {
        console.error("Error fetching Customer types:", error);
        // toast.error("Failed to fetch Customer types.");
      } finally {
        setLoading(false); 
      }
    };

   useEffect(() => {
    fetchcustomerTypes();
}, []);

  

 const spinAnimation = keyframes`
   0% { transform: rotate(0deg); }
   100% { transform: rotate(360deg); }
 `;
 const dotPositions = [
   { top: "5%", left: "50%" },
   { top: "20%", left: "80%" },
   { top: "50%", left: "95%" },
   { top: "80%", left: "80%" },
   { top: "95%", left: "50%" },
   { top: "80%", left: "20%" },
   { top: "50%", left: "5%" },
   { top: "20%", left: "20%" },
 ];


 
   

   

 return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#2e7faeff",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
  
      <MDBox mt={4} p={3} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h5">Customers</MDTypography>
      </MDBox>
  
      <Box display="flex" flexWrap="wrap" gap={2} justifyContent="center" mt={2}>
        {customerList.length > 0 ? (
          customerList.map((device) => (
            <Box
              key={device.id}
              onClick={() => {
                if (device.id == 1) {
                    navigate(`/DealerRegistration/${device.id}`);
                  } else if (device.id == 2) {
                    navigate(`/Farmer/${device.id}`);
                  }else {
                  toast.info("Navigation not defined for this customer type.");
                }
              }}
              sx={{
                  backgroundColor:"#2e7faeff",
                color: "#fff",
                padding: "8px 16px",
                borderRadius: "20px",
                fontWeight: "bold",
                fontSize: "14px",
                display: "inline-block",
                textTransform: "capitalize",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.15)",
                cursor: "pointer",
              }}
            >
              {device.customertype}
            </Box>
          ))
        ) : (
          <Typography variant="body2" sx={{ color: "gray", fontStyle: "italic" }}>
            No Data Available
          </Typography>
        )}
      </Box>
    </DashboardLayout>
  );
}

export default Customers;
